export enum EReportType {    
    TendersExcel,
    RatesExcel,
    DeliveriesExcel,
    ComplaintsExcel,
    CargoTransportersRatingsExcel,
    CargoTransportersRatingSummaryExcel,
    ReceivedDeliveries,
    DriverScore
}